import {Component, Input} from '@angular/core';
import {FeedFocusComponent} from "../feed-focus/feed-focus.component";
import {ModalController} from "ionic-angular";

/**
 * Generated class for the ProfilePostsComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'profile-posts',
  templateUrl: 'profile-posts.html'
})
export class ProfilePosts {

  @Input() latestPost;

  urlRegex: RegExp = /(\b(https?|http):\/\/[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|])/i;


  constructor(private modalCtrl: ModalController) {
  }

  linksParse(text) { // Converts links to hypertext links.
    return text.replace(this.urlRegex, function (url) {
      return '<a target="_blank" href="' + url + '">' + url + '</a>';
    });
  }

  seePost(postId) {
    let modal = this.modalCtrl.create(FeedFocusComponent, {postId: postId, isClubFeed: false});
    modal.present().then(() => {});
  }
}



// WEBPACK FOOTER //
// ./src/pages/employee/profile/profile-posts/profile-posts.ts